import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor() { }

  styleCustomCurrency(str) {
    function styleCurrency(match) {
      // console.log(match);
      return '<span class="custom_currency">' + match + '</span>';
    }
    return str.replace(/€\ ([\-]?[0-9]{1,3})([\.\ ]?[0-9]{3}?)*([\,\ ]([0-9]+|\-+))/g, styleCurrency);
  }
}
